import { render } from "./SurveyTakerQuestion.vue?vue&type=template&id=4a9afc9f"
import script from "./SurveyTakerQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyTakerQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__